import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requirePlan = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C6359]" data-testid="auth-loading">
        Opening Badi…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requirePlan && !["vital", "sovereign"].includes(user.plan)) {
    return <Navigate to="/pricing" replace />;
  }
  return children;
}
